/*************************************************/
/* SLIDER                                        */
/*************************************************/

import Swiper from "swiper";

export function slider() {

    const init = function () {

        var galleryThumbs = new Swiper(".swiper-thumbs", {
            spaceBetween: 2.5,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            breakpoints: {
                769: {
                    slidesPerView: 5
                },
                993: {
                    slidesPerView: 6
                }
            }
        });

        var galleryTop = new Swiper(".swiper-main", {
            effect: "slide",
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            thumbs: {
                swiper: galleryThumbs
            }
        });

        var banner = new Swiper(".pagehead-frontpage__slider.swiper", {
            effect: "slide",
            loop:true,
            pagination: {
                el: '.swiper-pagination',
              },
        });

    };

    init();
}